import { useFindCurrentCountryRuleQuery } from '../api';
import useGeoCodesByShippingQuery from './useGeoCodesByShippingQuery';

const useShippingQueriesError = () => {
    const countryRulesQuery = useFindCurrentCountryRuleQuery();
    const geoCodesQuery = useGeoCodesByShippingQuery();

    return (
        countryRulesQuery.isError ||
        (
            geoCodesQuery.isError &&
            (geoCodesQuery.error as any).status != 404
        )
    );
};

export default useShippingQueriesError;
